
import { connect } from 'react-redux';
import { IApplicationState } from 'ducks/reducers';
import { selectors as operationSelectors } from 'ducks/uiOperations';
import { selectors as uiSelectors } from 'ducks/ui';
import { selectors as formSelectors } from 'ducks/form';
import { selectors as financialSettingsSelectors } from 'ducks/supplierEnquiry/settings/financial';
import { selectors as generalSettingsSelectors } from 'ducks/supplierEnquiry/settings/general';

import SupplierSettings from './Settings';

const mapStateToProps = (state: IApplicationState) => ({
  operationMode: operationSelectors.operationMode(state),
  selectedTab: uiSelectors.selectedTab(state),
  selectedForm: formSelectors.selected(state),
  isBrowseLookUpOpen: uiSelectors.isBrowseLookUpOpen(state),
  financialSettings: financialSettingsSelectors.financialSettingsDetails(state),
  financialSettingsSchema: financialSettingsSelectors.financialSettingsSchema(state),
  generalSettings: generalSettingsSelectors.generalSettingsDetails(state),
  generalSettingsSchema: generalSettingsSelectors.generalSettingsSchema(state)
});

export default connect(mapStateToProps, {})(SupplierSettings);
